import styled, { css, keyframes } from 'styled-components';
import { Box, Text } from '@usealloy/component-library';

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const borderShimmer = keyframes`
  0%, 100% { border-color: var(--cl-border-default); }
  50% { border-color: var(--cl-purple-400); }
`;

export const AIAnalysisContainer = styled(Box)<{ $isAdmin: boolean }>`
  width: 100%;
  position: relative;

  ${({ $isAdmin }) => $isAdmin && css`
    padding: var(--cl-space-2);
    border: 1px dashed var(--cl-border-default);
    border-radius: 20px;
  `}
`;

export const StyledIframe = styled.iframe<{ $isLoading: boolean; $isInline: boolean }>`
  border: none;
  border-radius: var(--cl-radius-4);
  background: none;
  position: relative;

  ${({ $isLoading }) => $isLoading && css`
    border: 1px solid var(--cl-border-default);
    background: color-mix(in srgb, var(--cl-purple-100) 50%, transparent);
    animation: ${borderShimmer} 2s infinite ease-in-out;
  `}

  ${({ $isInline }) => $isInline && css`
    margin-bottom: calc(var(--cl-space-3) * -1);
    border: none;
    border-radius: 0;
    background: transparent;
  `}
`;

export const StyledLoadingText = styled(Text)`
  color: var(--cl-text-secondary);
  animation: ${shimmer} 2s infinite;
  background: linear-gradient(90deg, currentColor 0%, rgba(255,255,255,0.5) 50%, currentColor 100%);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  left: var(--cl-space-4);
  position: absolute;
`;
